import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

// const locale = 'nl-NL'

const currencyLangList = {
  EUR: {
    language: 'nl'
  },
  PLN: {
    language: 'pl'
  },
  CHF: {
    language: 'ch'
  },
  USD: {
    language: 'en'
  },
  GBP: {
    language: 'en'
  },
  DKK: {
    language: 'da'
  },
  CAD: {
    language: 'en'
  }
}

@Pipe({
  name: 'price'
})
export class PricePipe implements PipeTransform {

  // transform(value: number, currency?: string): any {
  //   return (value || 0).toLocaleString(locale, {
  //     style: 'currency',
  //     currency: currency || 'EUR'
  //   })
  // }

  public transform(value: number, currency: string = 'EUR', language?: string): string {
    const currencySymbol = getCurrencySymbol(currency, 'narrow');
    let languageToUse = language;

    if (!languageToUse) {
      const currencyLanguage = currencyLangList[currency];

      if (currencyLanguage && currencyLanguage.language) {
        languageToUse = currencyLanguage.language;
      } else {
        languageToUse = 'nl';
      }
    }

    return formatCurrency(value, languageToUse, currencySymbol);
  }

}
